import React from 'react';
import { Container, Button } from 'react-bootstrap';
import icons from './Icons';
import './legal.css';

const ThankYou = ({ onNavigate }) => {
  const handleNavClick = (pageId) => {
    if (onNavigate) {
      onNavigate(pageId);
    } else {
      window.location.hash = pageId;
    }
  };

  return (
    <div className="thankyou-page-wrapper py-5 d-flex align-items-center min-vh-75">
      <Container className="px-3 px-lg-5">
        <div className="text-center mx-auto" style={{ maxWidth: '640px' }}>
          {/* Animated Success Badge */}
          <div className="mb-4 d-inline-flex align-items-center justify-content-center p-3 rounded-circle" style={{
            width: '84px',
            height: '84px',
            background: 'rgba(34, 197, 94, 0.12)',
            border: '2px solid rgba(34, 197, 94, 0.35)',
            boxShadow: '0 0 30px rgba(34, 197, 94, 0.25)'
          }}>
            <svg viewBox="0 0 24 24" width="42" height="42" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>

          <div className="mb-3">
            <span className="legal-badge">
              <span className="legal-meta-dot dot-orange" />
              INQUIRY RECEIVED
            </span>
          </div>

          <h1 className="legal-title mb-3">Thank You!</h1>
          <p className="legal-subtitle mb-4">
            We have received your project details. Our growth architects and systems engineers are already reviewing your requirements.
          </p>

          <div className="p-4 rounded-4 mb-4 text-start" style={{
            background: 'var(--bg-card)',
            border: '1px solid var(--border-subtle)',
            boxShadow: 'var(--card-shadow)'
          }}>
            <h5 className="fw-bold mb-3 d-flex align-items-center gap-2" style={{ color: 'var(--text-primary)' }}>
              <span>🚀 What Happens Next?</span>
            </h5>
            <ul className="list-unstyled mb-0 d-flex flex-direction-column flex-column gap-2.5 small" style={{ color: 'var(--text-secondary)' }}>
              <li className="d-flex align-items-start gap-2">
                <span className="text-orange fw-bold">1.</span>
                <span><strong>24-Hour Review:</strong> Our senior strategists review your goals and existing architecture.</span>
              </li>
              <li className="d-flex align-items-start gap-2">
                <span className="text-orange fw-bold">2.</span>
                <span><strong>Custom Blueprint:</strong> We formulate a preliminary strategic roadmap tailored to your pipeline.</span>
              </li>
              <li className="d-flex align-items-start gap-2">
                <span className="text-orange fw-bold">3.</span>
                <span><strong>Discovery Call:</strong> We'll reach out directly via email or phone to confirm a time that works for you.</span>
              </li>
            </ul>
          </div>

          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
            <Button
              variant="light"
              className="btn-start-project px-4 py-2.5 d-inline-flex align-items-center justify-content-center gap-2"
              onClick={() => handleNavClick('home')}
            >
              <span>Back to Home</span>
              {icons.arrowRight}
            </Button>
            <Button
              variant="outline-secondary"
              className="px-4 py-2.5 rounded-3 fw-semibold text-body border-1"
              style={{ background: 'var(--bg-card)', borderColor: 'var(--border-subtle)' }}
              onClick={() => handleNavClick('case-studies')}
            >
              Explore Case Studies
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ThankYou;
